import AISVG from "../../../assets/AI.jsx";

const getInspectionConfig = (contract) => {
    return {
    title: "Inspection",
    taskKey: "inspection", 
    subText: 'Steps to manage inspection, some steps may be optional', 
    // due: `Objection Deadline: ${contract?.data?.dateFields?.inspection_objection_deadline?.date}`, 
    due: (deadline) => `Objection Deadline: ${deadline}`,
    subSteps: [
        {
            title: "Additional Information",
            taskKey: "additionalInspectionInfo",
            subText: (
                <>
                Per the Colorado contract you can (and should) order an inspection, which you are responsible for ordering and paying for. If you find unsatisfactory conditions, you can either:
                <br />
                <strong>Terminate:</strong> Cancel the contract by notifying the seller in writing before the Inspection Termination Deadline (if you haven’t already objected).
                <br />
                <strong>Object:</strong> Submit an objection below detailing the issues that need correction by the Inspection Objection Deadline.
                <br />
                If no settlement is reached by the Inspection Resolution Deadline—and you don’t withdraw your objection—the contract will terminate.
              </>
            )
        },
        {
        title: "Schedule Inspector",
        taskKey: "scheduleInspector",
        subText: "Schedule your inspection with a Shishito professional or your own. Mark as complete when done, with the date of inspection.",
        actionTexts: ["Complete", "Schedule"],
        },
        {
        title: <>Upload Report <small>(Optional)</small></>,
        taskKey: "uploadReport",
        subText: "Upload your inspection report if you want Shishito AI to analyze the report.",
        actionTexts: ["Upload"],
        type: "upload"
        },
        {
        title: <div className="inline-flex gap-2">AI Analysis of Inspection Report <small>(Optional)</small></div>,
        taskKey: "analyzeReport",
        subText: "Analyze your Inspection Report using Shishito AI. This will help you summarize the report and prepare for next steps.",
        actionTexts: ["Analyze"]
        },
        {
            title: <>Inspection Objection <small>(Optional)</small></>,
            taskKey: "generateInspectionObjection",
            subText: "Generate an objection based on your report. After you the objection form is signed by all buyer's, download it and send it to the seller.",
            actionTexts: ["Generate"]
        },
        {
            title: <>Negotiate Repairs <small>(Optional)</small></>,
            taskKey: "negotiateRepairs",
            subText: "After you submit a written objection outlining the issues, you can negotiate with the seller to resolve them.",
        },
        {
            title: <>Post Objection <small>(Optional)</small></>,
            taskKey: "postInspectionObjection",
            subText: <>Options after generating an objection. <br />
            <b>Resolution Deadline:</b> {contract?.data?.dateFields?.inspection_resolution_deadline?.dayOfWeek} {contract?.data?.dateFields?.inspection_resolution_deadline?.date}
            <br />
            <b>Termination Deadline:</b> {contract?.data?.dateFields?.inspection_termination_deadline?.dayOfWeek} {contract?.data?.dateFields?.inspection_termination_deadline?.date}
            </>,
            actionTexts: ["Resolve", "Withdraw", "Terminate"]
        },
    ] 
  };
};
  
export default getInspectionConfig;
  